import * as React from 'react';
import { SVGProps } from 'react';

const SvgCancelCircle = (
  props: SVGProps<SVGSVGElement> & React.HTMLAttributes<HTMLElement>
) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm6-8a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM5 7a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H5Z"
      fill="#000"
    />
  </svg>
);
export default SvgCancelCircle;
